export const darkenColor = (colorCode: string, ratio: number) => {
  if (colorCode === '#fff') return colorCode
  // カラーコードをRGB値に変換
  const hex = colorCode.replace(/^#/, '')
  const bigint = parseInt(hex, 16)
  const red = (bigint >> 16) & 255
  const green = (bigint >> 8) & 255
  const blue = bigint & 255

  // 色を濃くする処理
  const darkerRed = Math.floor(red * (1 - ratio))
  const darkerGreen = Math.floor(green * (1 - ratio))
  const darkerBlue = Math.floor(blue * (1 - ratio))

  // 新しい色を16進数に変換
  const darkerHex = ((darkerRed << 16) + (darkerGreen << 8) + darkerBlue).toString(16)

  // 16進数をカラーコード形式に整形
  return `#${darkerHex.padStart(6, '0')}`
}
